const CAP62 = {
  id: 62,
  slug: "cap62-en-resumen-y-reflexiones-finales",
  title: "Capítulo 62 — En resumen y reflexiones finales",
  module: 6,
  sections: [
    {
      heading: "Resumen del capítulo",
      text: [
        "En este capítulo se desarrolla el tema: En resumen y reflexiones finales."
      ]
    }
  ]
};

export default CAP62;
